import * as React from "react";
import SecretSidebar from "../Secret/SecretSidebar";
import { createBrowserHistory } from "history";
import {
  LoadSecret,
  GetSecretList,
  CreateSecret,
  UpdateSecret,
  DeleteSecret
} from "../../../../actions/SecretActions";
import SecretStore from "../../../../stores/SecretStore";
import { Link } from "react-router-dom";
const customHistory = createBrowserHistory();
class SecretView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentSecret: {
        id: 0,
        name: "",
        value: ""
      },
      secretId: 0,
      isDirty: false,
      error: "",
      isSaving: false,
      deleteStatus: 0,
      isEncrypted: false
    };
    this.updateSecret = this.updateSecret.bind(this);
    this.onStoreUpdate = this.onStoreUpdate.bind(this);
    this.handleNameChange = this.handleNameChange.bind(this);
    this.handleValueChange = this.handleValueChange.bind(this);
    this.handleSaveClick = this.handleSaveClick.bind(this);
    this.startDelete = this.startDelete.bind(this);
    this.deleteSecret = this.deleteSecret.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.handleSaveClick2 = this.handleSaveClick2.bind(this);
  }
  componentDidMount() {
    SecretStore.addChangeListener(this.onStoreUpdate);
    this.updateSecret();
  }
  componentWillUnmount() {
    SecretStore.removeChangeListener(this.onStoreUpdate);
  }
  componentDidUpdate() {
    this.updateSecret();
  }
  updateSecret() {
    let loc = window.location.pathname;
    let pathParts = loc.split("/");
    let secretId = parseInt(pathParts[pathParts.length - 1], 10);
    if (secretId !== 0 && (this.state.currentSecret === void 0 || this.state.currentSecret.id !== secretId)) {
      LoadSecret(secretId);
    } else if (secretId === 0 && this.state.currentSecret !== void 0 && this.state.currentSecret.id !== 0) {
      let currentSecret = {};
      currentSecret.id = 0;
      currentSecret.name = "";
      currentSecret.value = "";
      this.setState({
        currentSecret,
        secretName: ""
      });
    }
  }
  onStoreUpdate() {
    let lastAction = SecretStore.lastChange();
    if (lastAction === "SecretLoadOne") {
      let secret = SecretStore.getCurrentSecret();
      this.setState({
        currentSecret: secret,
        secretName: secret.name,
        isDirty: false,
        isSaving: false
      });
    }
    if (lastAction === "SecretCreateOne") {
      let lastError = SecretStore.getLastError();
      if (lastError === "" || lastError === void 0) {
        let newSecret = SecretStore.getCurrentSecret();
        if (newSecret.id !== this.state.currentSecret.id) {
          customHistory.push(`/Admin/SecretView/${newSecret.data.id}`);
        }
        this.setState({
          error: "",
          currentSecret: newSecret,
          currentName: newSecret.name,
          isSaving: false,
          isDirty: false
        });
        GetSecretList();
      } else {
        this.setState({ isSaving: false, error: lastError });
      }
    }
    if (lastAction === "SecretUpdateOne") {
      let lastError = SecretStore.getLastError();
      if (lastError === "" || lastError === void 0) {
        let newSecret = SecretStore.getCurrentSecret();
        if (newSecret.data.id !== this.state.currentSecret.id) {
          customHistory.push(`/Admin/SecretView/${newSecret.data.id}`);
        }
        this.setState({
          error: "",
          currentSecret: newSecret,
          currentName: newSecret.name,
          isSaving: false,
          isDirty: false
        });
        GetSecretList();
      } else {
        this.setState({ isSaving: false, error: lastError });
      }
    }
    if (lastAction === "SecretDelete") {
      let lastError = SecretStore.getLastError();
      if (lastError === "") {
        let link = document.getElementById("secretHome");
        link.click();
      } else {
        this.setState({ isSaving: false, error: lastError });
      }
    }
  }
  handleNameChange(e) {
    let currentSecret = this.state.currentSecret;
    currentSecret.name = e.target.value;
    this.setState({ currentSecret, isDirty: true });
  }
  handleValueChange(e) {
    let currentSecret = this.state.currentSecret;
    currentSecret.value = e.target.value;
    this.setState({ currentSecret, isDirty: true });
  }
  handleSaveClick(e) {
    this.setState({ isSaving: true, isEncrypted: false });
    if (this.state.currentSecret.id === 0) {
      CreateSecret(this.state.currentSecret);
    } else {
      UpdateSecret(this.state.currentSecret);
    }
  }
  handleSaveClick2(e) {
    this.setState({ isSaving: true, isEncrypted: true });
    if (this.state.currentSecret.id === 0) {
      CreateSecret(this.state.currentSecret, this.state.isEncrypted);
    } else {
      UpdateSecret(this.state.currentSecret, this.state.isEncrypted);
    }
  }
  startDelete() {
    this.setState({ deleteStatus: 1 });
  }
  deleteSecret() {
    DeleteSecret(this.state.currentSecret.id);
    this.setState({ deleteStatus: 0 });
  }
  cancelDelete() {
    this.setState({ deleteStatus: 0 });
  }
  render() {
    return /* @__PURE__ */ React.createElement("div", { className: "container-fluid", style: { height: "100%" } }, /* @__PURE__ */ React.createElement("div", { className: "row flex-nowrap", style: { height: "100%" } }, /* @__PURE__ */ React.createElement(SecretSidebar, null), /* @__PURE__ */ React.createElement(
      Link,
      {
        id: "secretHome",
        className: "nav-link",
        to: `/Admin/Secret`,
        style: { display: "none" }
      }
    ), this.state.currentSecret !== void 0 && /* @__PURE__ */ React.createElement(
      "div",
      {
        className: "flex-fill",
        style: { backgroundColor: "#efefef", overflow: "scroll" }
      },
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "card",
          style: {
            marginTop: "20px",
            marginLeft: "30px",
            marginRight: "30px",
            maxHeight: "620px"
          }
        },
        /* @__PURE__ */ React.createElement("div", { className: "card-header" }, /* @__PURE__ */ React.createElement("h4", null, /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-key" }), "  ", this.state.currentSecret.name)),
        /* @__PURE__ */ React.createElement("div", { className: "card-body" }, /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "nameTxt", className: "form-label" }, "Name:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "nameTxt",
            value: this.state.currentSecret.name,
            onChange: this.handleNameChange
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "mb-3" }, /* @__PURE__ */ React.createElement("label", { htmlFor: "valueTxt", className: "form-label" }, "Value:"), /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            className: "form-control",
            id: "valueTxt",
            value: this.state.currentSecret.value,
            onChange: this.handleValueChange
          }
        )), /* @__PURE__ */ React.createElement("div", { className: "mb-3", style: { marginTop: "8px" } }, this.state.isDirty && !this.state.isSaving && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary",
            onClick: this.handleSaveClick
          },
          "Save"
        ), this.state.isDirty && !this.state.isSaving && /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary",
            style: { marginLeft: "8px" },
            onClick: this.handleSaveClick2
          },
          "Save Encrypted"
        ), !this.state.isDirty && !this.state.isSaving && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { className: "btn btn-primary disabled" }, "Save"), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-primary disabled",
            style: { marginLeft: "8px" },
            onClick: this.handleSaveClick2
          },
          "Save Encrypted"
        ), /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "btn btn-danger",
            style: { marginLeft: "6px" },
            onClick: this.startDelete
          },
          "Delete"
        )), this.state.isSaving && /* @__PURE__ */ React.createElement("i", { className: "fa-solid fa-spinner", size: "2x", spin: true }), this.state.deleteStatus === 1 && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          /* @__PURE__ */ React.createElement("p", null, "Are you sure you want to delete this secret?"),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-danger",
              onClick: this.deleteSecret
            },
            "Yes - Delete"
          ),
          /* @__PURE__ */ React.createElement(
            "button",
            {
              className: "btn btn-secondary",
              style: { marginLeft: "6px" },
              onClick: this.cancelDelete
            },
            "Cancel"
          )
        ), this.state.error !== "" && /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "alert alert-danger",
            style: { marginTop: "6px" },
            role: "alert"
          },
          this.state.error
        )))
      )
    )));
  }
}
export default SecretView;
